import { Stack, Typography } from "@mui/material";
import React from "react";

export const WorkOrderSelectRender = ({
  label,
  part = {},
  lotNumber,
  showPart = true,
}) => {
  const sx = { fontSize: "11px !important", textWrap: "nowrap" };
  const hightlight = {
    variant: "caption",
    sx: { ...sx, color: "hubColors.mainFocus", fontWeight: 500 },
  };
  const lotProps = showPart ? { sx, variant: "caption" } : hightlight;

  return (
    <Stack direction="row" gap="10px" alignItems="center">
      <Typography sx={sx} variant="caption">
        {label}
      </Typography>
      {showPart && <Typography {...hightlight}>{part?.partName}</Typography>}
      <Typography {...lotProps}>{lotNumber}</Typography>
    </Stack>
  );
};

export const renderValue = (value, options) => {
  const op = options?.find((o) => o.id === value);
  return <WorkOrderSelectRender {...op} showPart={false} />;
};

export default WorkOrderSelectRender;
